module.exports = __webpack_public_path__ + "static/media/steps_icon3.aa5de4f1.svg";